import { computed, ref, watch } from "vue";
import { b as isClient } from "../utils/ssr-fd33979c.mjs";
const useClientOnly = (cb) => {
  const isMounted = computed(isClient);
  const result = ref(null);
  watch(isMounted, () => {
    if (isMounted.value) {
      result.value = cb();
    }
  }, { immediate: true });
  return result;
};
export {
  useClientOnly as u
};
//# sourceMappingURL=useClientOnly-c9844a99.mjs.map
